// extracted by mini-css-extract-plugin
export default {"inputWrapper":"shopify-detail_inputWrapper__ovjin"};